import React from "react";
import BSInput from "../../../common/js/components/BSInput";
import BSSelect from "../../../common/js/components/BSSelect";
import { leaseTypeTypes } from "../types/leaseTypeTypes";
import { toTwoDec } from "../utils/operations";
import "./LeaseDetailForm.css";

const LeaseDetailForm = (props) => {
    const { errors, deal, disableInputs, handleAutocalculateTiSf, handleBlurValidate, leaseDetail, onChange, useType } =
        props;

    const handleLeaseDetailChange = (event) => {
        onChange(event);
    };

    const isComplete = deal?.isPartiallyComplete === false;

    return (
        <React.Fragment>
            {/*************** All Starts Here ***************/}

            <div className="leaseDetailFlexContainer">
                <div className=" leaseDetailFlexContainerUnresponsive flexGrowSingle">
                    <div className="flexGrowSingle">
                        <BSInput
                            id="tiRate"
                            label={isComplete ? "TI($/SF)*" : "TI($/SF)"}
                            errorText="Required (Field must be a number between 0 and 1000)"
                            helperText={isComplete ? "Required (ex. 981.01)" : ""}
                            placeholder="Enter $/sf"
                            error={isComplete ? errors.tiRate : false}
                            value={leaseDetail.tiRate}
                            onChange={handleAutocalculateTiSf}
                            startAdornment="$"
                            disabled={disableInputs === true}
                            numeric
                            onBlurValidate={(id, value) => handleBlurValidate("leaseDetails", id, value)}
                        />
                    </div>
                    <div>
                        <div className="leaseDetailsEquals"> = </div>
                    </div>
                    <div className="flexGrowSingle">
                        <BSInput
                            id="tiTotal"
                            placeholder="Total Amount"
                            value={toTwoDec(leaseDetail.tiTotal)}
                            disabled={true}
                            startAdornment="$"
                        />
                    </div>
                </div>
                <div className=" leaseDetailFlexContainerUnresponsive flexGrowSingle">
                    <div className="flexGrowSingle">
                        <BSSelect
                            id="leaseType"
                            label="Lease Type*"
                            helperText="Required"
                            errorText="Required"
                            value={leaseDetail.leaseType}
                            error={errors.leaseType}
                            onChange={handleLeaseDetailChange}
                            placeholder="Select lease type..."
                            disabled={disableInputs}
                            options={[
                                {
                                    value: "",
                                    label: "Select",
                                    disabled: true,
                                },
                                ...leaseTypeTypes,
                            ]}
                            onBlurValidate={(id, value) => handleBlurValidate("leaseDetails", id, value)}
                        />
                    </div>
                    <div className="flexGrowSingle">
                        <BSInput
                            id="netEffectiveRent"
                            label="NER (Net Effective Rent)"
                            placeholder="Net Effective Rent"
                            error={errors.netEffectiveRent}
                            value={leaseDetail.netEffectiveRent}
                            onChange={handleLeaseDetailChange}
                            startAdornment="$"
                            disabled={disableInputs === true}
                            numeric
                        />
                    </div>
                </div>
            </div>

            {/*************** All Ends Here ***************/}

            {/*************** All Except Land Starts Here ***************/}
            {useType !== "Land" && (
                <React.Fragment>
                    <div className="leaseDetailFlexContainer">
                        <div className=" leaseDetailFlexContainerUnresponsive flexGrowSingle">
                            <div className="flexGrowSingle">
                                <BSInput
                                    id="movingAllowanceAmount"
                                    label="Moving Allowance ($)"
                                    errorText="(ex. 981.01)"
                                    placeholder="Enter moving allowance"
                                    error={errors.movingAllowanceAmount}
                                    value={leaseDetail.movingAllowanceAmount}
                                    disabled={disableInputs === true}
                                    startAdornment="$"
                                    onChange={handleLeaseDetailChange}
                                    onBlurValidate={(id, value) => handleBlurValidate("leaseDetails", id, value)}
                                />
                            </div>
                            <div className="flexGrowSingle">
                                <BSInput
                                    id="buyerTenantBusinessType"
                                    label="Tenant Business Type"
                                    placeholder="Enter tenant business type"
                                    error={errors.buyerTenantBusinessType}
                                    value={leaseDetail.buyerTenantBusinessType}
                                    disabled={disableInputs === true}
                                    onChange={handleLeaseDetailChange}
                                />
                            </div>
                        </div>
                        <div className=" leaseDetailFlexContainerUnresponsive flexGrowSingle">
                            <div className="flexGrowSingle">
                                <BSInput
                                    id="naicsCode"
                                    label="BUSINESS NAICS CODE"
                                    helperText="Numeric only (ex. 98101)"
                                    persistHelperText
                                    errorText="Numeric only (ex. 98101)"
                                    placeholder="Enter business NAICS code"
                                    error={errors.naicsCode}
                                    value={leaseDetail.naicsCode}
                                    disabled={disableInputs === true}
                                    onChange={handleLeaseDetailChange}
                                    onBlurValidate={(id, value) => handleBlurValidate("leaseDetails", id, value)}
                                />
                            </div>
                            <div className="flexGrowSingle">
                                <BSInput
                                    id="sicCode"
                                    label="BUSINESS SIC CODE"
                                    helperText="Numeric only (ex. 98101)"
                                    persistHelperText
                                    errorText="Numeric only (ex. 98101)"
                                    placeholder="Enter business SIC code"
                                    error={errors.sicCode}
                                    value={leaseDetail.sicCode}
                                    disabled={disableInputs === true}
                                    onChange={handleLeaseDetailChange}
                                    onBlurValidate={(id, value) => handleBlurValidate("leaseDetails", id, value)}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="leaseDetailFlexContainerUnresponsive">
                        <div className="flexGrowSingle">
                            <BSInput
                                id="previousLocation"
                                label="PREVIOUS LOCATION"
                                placeholder="Enter previous location"
                                error={errors.previousLocation}
                                value={leaseDetail.previousLocation}
                                onChange={handleLeaseDetailChange}
                                disabled={disableInputs === true}
                            />
                        </div>
                        <div className="flexGrowSingle">
                            <BSInput
                                id="currentSf"
                                label="PREVIOUS SQUARE FEET"
                                placeholder="Enter previous square feet"
                                error={errors.currentSf}
                                value={leaseDetail.currentSf}
                                disabled={disableInputs === true}
                                onChange={handleLeaseDetailChange}
                                integer
                                onBlurValidate={(id, value) => handleBlurValidate("leaseDetails", id, value)}
                            />
                        </div>
                        <div className="flexGrowSingle">
                            <BSInput
                                id="squareFeetChange"
                                label="SQUARE FEET CHANGE"
                                placeholder="Square feet changed"
                                error={errors.squareFeetChange}
                                errorText="Numeric only (ex. 98101)"
                                value={leaseDetail.squareFeetChange}
                                disabled={disableInputs === true}
                                onChange={handleLeaseDetailChange}
                                onBlurValidate={(id, value) => handleBlurValidate("leaseDetails", id, value)}
                            />
                        </div>
                    </div>
                </React.Fragment>
            )}

            {/*************** All Except Land Ends Here ***************/}
        </React.Fragment>
    );
};

export default LeaseDetailForm;
